<template>
  <div>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup"title="Virtual Assistant"/>
          <virtual-assistant :id="currentGroup.id" type="group"/>
    </div>
  </div>

</template>
<script>
  import api from '../../services/groupsPlaceApi.js'
  import {mapState} from 'vuex'
  import bannerSmall from '../group/BannerSmall'
  import VirtualAssistant from "../event/VirtualAssistant";

  import {mdbContainer,} from 'mdbvue';

  export default {
    name: "group-assistant",
    order: 1,
    components: {
      mdbContainer,
      bannerSmall,
      VirtualAssistant
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        url: ""
      }
    },
    async mounted() {
      document.title = "Virtual Assistant"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "admin");
      }
    },
    methods: {

    }
  };

</script>

